const require_errors = require("./errors.cjs");
const require_isRepositoryName = require("./isRepositoryName.cjs");
//#region src/getRepositoryEndpoint.ts
/**
* Get a repository's Prismic Content API endpoint.
*
* @example
* 	;```ts
* 	getRepositoryEndpoint("my-repo")
* 	// => "https://my-repo.cdn.prismic.io/api/v2"
* 	```
*
* @typeParam RepositoryName - Name of the Prismic repository.
* @param repositoryName - Name of the repository.
* @returns The repository's Prismic Content API endpoint.
* @throws {@link Error} Thrown if an invalid repository name is provided.
*/
const getRepositoryEndpoint = (repositoryName) => {
	if (require_isRepositoryName.isRepositoryName(repositoryName)) return `https://${repositoryName}.cdn.prismic.io/api/v2`;
	else throw new require_errors.PrismicError(`An invalid Prismic repository name was given: ${repositoryName}`, void 0, void 0);
};
//#endregion
exports.getRepositoryEndpoint = getRepositoryEndpoint;

//# sourceMappingURL=getRepositoryEndpoint.cjs.map